export class Area {
  constructor(id, name, cityId) {
    this.id = id;
    this.name = name;
    this.cityId = cityId;
  }

  // set areas from response array
  static setAreas(areas) {
    return areas.map((area) => new Area(area.id, area.name, area.city_id));
  }
}
